import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

class GuestJoinPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      guestName: ''
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { roomName, companyId } = this.props.params;
    const { guestName } = this.state;
    
    // Redirect to the video room with the guestName as query param
    const baseUrl = companyId ? `/custom/${companyId}/v/${roomName}` : `/v/${roomName}`;
    this.props.dispatch(push(`${baseUrl}/?guestName=${encodeURIComponent(guestName || 'Gast')}`));
  };

  render() {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#1e293b',
        color: '#f8fafc',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }}>
        <div style={{
          backgroundColor: '#0f172a',
          padding: '40px',
          borderRadius: '16px',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
          border: '1px solid #334155',
          maxWidth: '400px',
          width: '90%',
          textAlign: 'center'
        }}>
          <div style={{ marginBottom: '24px' }}>
            <img src="/assets/img/logo.svg" alt="tele-LOOK" style={{ height: '40px' }} />
          </div>
          
          <h2 style={{ fontSize: '24px', fontWeight: 'bold', margin: '0 0 12px 0' }}>
            Als Gast beitreten
          </h2>
          <p style={{ color: '#94a3b8', fontSize: '15px', margin: '0 0 32px 0', lineHeight: '1.5' }}>
            Sie wurden zu einem Video-Call eingeladen. Bitte geben Sie Ihren Namen ein, um dem Raum beizutreten.
          </p>

          <form onSubmit={this.handleSubmit}>
            <div style={{ marginBottom: '24px', textAlign: 'left' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 'bold', color: '#cbd5e1' }}>
                Ihr Name (optional)
              </label>
              <input
                type="text"
                autoFocus
                placeholder="z.B. Max Mustermann"
                value={this.state.guestName}
                onChange={(e) => this.setState({ guestName: e.target.value })}
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  borderRadius: '8px',
                  border: '1px solid #475569',
                  backgroundColor: '#1e293b',
                  color: '#f8fafc',
                  fontSize: '16px',
                  outline: 'none'
                }}
              />
            </div>
            
            <button
              type="submit"
              className="lh-btn lh-btn-primary lh-btn-block"
              style={{ padding: '14px', fontSize: '16px', fontWeight: 'bold' }}
            >
              Dem Gespräch beitreten
            </button>
          </form>
        </div>
      </div>
    );
  }
}

export default connect()(GuestJoinPage);
